import React, { useEffect, useState } from 'react';
import { Button, Divider, Grid, Typography, TextField, Box, Card, CardHeader, CardContent, CircularProgress, FormControl, MenuItem } from '@mui/material';
import 'react-datepicker/dist/react-datepicker.css';
import { SSPCommonButton } from '../../CommonComponents';
import { StyledDatePicker, employeHistorycolumns, paymentTypeOptions, } from './Styles'
import { post } from "../../services";
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import moment from 'moment';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { styles } from './Styles';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download';
import { HSBC_VENDOR_PAYMENTS_URL, hsbcBody } from "./hsbcApi";

const commonBorderStyle = {
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "lightgray",
        },
        "&:hover fieldset": {
            borderColor: "lightgray",
        },
        "&.Mui-focused fieldset": {
            borderColor: "lightgray",
        }
    }
};

const EmployeeHistory = ({ }) => {
    const [supplierCode, setsupplierCode] = useState("");
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [startdate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [row, setRows] = useState([]);
    const [erropenModal, seterrOpenModal] = useState(false);
    const [paymentType, setpaymentType] = useState('PaymentType');
    const [EmpData, setEmpData] = useState([]);

    useEffect(() => {
        rowFetch();
    }, []);
    const rowFetch = async () => {
        setLoading(true)
        let response = await post(
            HSBC_VENDOR_PAYMENTS_URL,
            hsbcBody("/show_summary", {
                "start_date": "",
                "end_date": "",
                "payment_type": ""
            }),
            true,
            false
        );
        if (response?.status === "success") {
            setEmpData(response?.body?.data)
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);
            setLoading(false)

        } else if (response?.status === "error") {
            setLoading(false)
            if (response?.body?.message === "Invalid Request") {
                seterrOpenModal(true);

            } else {
                setmessage(response?.body?.message || response?.message);
                setmodalOpener(true);
            }
        }

    };

    const handleStartDate = (date) => {
        setStartDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : null);
    };
    const handleEndDateChange = (date) => {
        setEndDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59) : null);
    };
    const handleSearchFile = async () => {
        if (startdate && !endDate) {
            setmessage("End date is required if start date is selected.");
            setmodalOpener(true);
            return;
        }

        if (!startdate && !endDate && !supplierCode) {
            setmessage("Please select start and end dates.");
            setmodalOpener(true);
            return;
        }

        setLoading(true)
        const formatedStartDate = moment(new Date(startdate)).format('YYYY-MM-DD');
        const formatedendDate = moment(new Date(endDate)).format('YYYY-MM-DD');
        let response = await post(
            HSBC_VENDOR_PAYMENTS_URL,
            hsbcBody("/show_summary", {
                "start_date": startdate ? formatedStartDate : "",
                "end_date": endDate ? formatedendDate : "",
                "payment_type": paymentType == 'PaymentType' ? "" : paymentType
            }),
            true,
            false
        );
        if (response?.status === "success") {
            setEmpData(response?.body?.data)
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);
            setLoading(false)

            setStartDate(null)
            setEndDate(null)
            setpaymentType('PaymentType')
        } else if (response?.status === "error") {
            setStartDate(null)
            setEndDate(null)
            setpaymentType('PaymentType')
            if (response?.body?.message === "Invalid Request") {
                setLoading(false)
                seterrOpenModal(true);

            } else {
                setmessage(response?.body?.message || response?.message);
                setmodalOpener(true);
                setLoading(false)
            }

        }
        else {
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
            setLoading(false)
        }
    }

    const handleDownloadFile = () => {
        const worksheet = XLSX.utils.json_to_sheet(EmpData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'EmployeeHistory');
        XLSX.writeFile(workbook, 'EmployeeHistory.xlsx');
    }


    return (
        <div style={styles.container}>
            <Typography style={styles.title}> Holocron : HSBC Employee History </Typography>
            <Divider sx={styles.divider} />
            <div style={styles.sectionContainer}>
                <Card sx={styles.card}>
                    <CardHeader
                        p={2}
                        sx={styles.locationCodeCardHeader}
                        title={"Download paid invoices"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                    />
                    <Divider />
                    <CardContent sx={{ ...styles.locationCardContent, paddingTop: 5, paddingBottom: 3 }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={4} lg={3} sx={styles.dateGrid}>
                                <Typography>Start Date:</Typography>
                                <StyledDatePicker
                                    selected={startdate}
                                    onChange={handleStartDate}
                                    maxDate={new Date()}
                                    placeholderText="Start Date"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} sx={styles.dateGrid}>
                                <Typography>End Date:</Typography>
                                <StyledDatePicker
                                    selected={endDate}
                                    onChange={handleEndDateChange}
                                    maxDate={new Date()}
                                    minDate={startdate}
                                    placeholderText="End Date"
                                />
                            </Grid>
                            <Grid item>
                                <Typography>Payment Type:</Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} md={2} sx={{ marginLeft: 2 }}>
                                <FormControl fullWidth sx={styles.approvePaymentFormControl}>
                                    <TextField
                                        select
                                        fullWidth
                                        value={paymentType}
                                        onChange={(e) => setpaymentType(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        sx={commonBorderStyle}
                                    >
                                        {paymentTypeOptions?.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.7} >
                                <Box sx={{ ...styles.downloadBttnStyle, justifyContent: 'flex-end', }}>
                                    <SSPCommonButton btnText={"Search"} btnFunction={() => handleSearchFile()} />
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <ErrorModal openModal={erropenModal} />
                <Card sx={styles.card} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Payment Summary"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1" },
                        }}
                        action={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                                <Button
                                    onClick={() => handleDownloadFile()}
                                    sx={{ textTransform: 'none', minWidth: 0, padding: 0 }}
                                >
                                    <DownloadIcon sx={{ color: "#0160F1", fontSize: 30 }} />
                                </Button>


                            </Box>
                        }
                    />



                    <Divider />
                    <CardContent sx={styles.cardContent} >
                        {loading && (
                            <div style={styles.loaderOverlay}>
                                <CircularProgress />
                            </div>
                        )}
                        <Box sx={{ display: { lg: "flex" }, }} >
                        </Box>
                        <div>
                            <div style={styles.tableContainer}>
                                <Box sx={styles.tableContainer}>
                                    <DataGrid
                                        rowHeight={80}
                                        showCellRightBorder={true}
                                        sx={{
                                            ".MuiDataGrid-columnHeaderTitle": {
                                                fontWeight: "bold !important",
                                            },
                                            ".MuiDataGrid-cell": {
                                                fontSize: "0.8rem",
                                            },
                                            overflowX: "scroll",
                                        }}
                                        rows={row}
                                        columns={employeHistorycolumns}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 10,
                                                },
                                            },
                                        }}
                                        headerClassName="header-center"
                                        rowsPerPageOptions={[10]}
                                        pageSize={10}
                                        getRowId={(row) => row.id}
                                        components={{
                                            Toolbar: GridToolbar,
                                        }}
                                        componentsProps={{
                                            Toolbar: {
                                                showQuickFilter: true,
                                                quickFilterProps: { debounceMs: 500 },
                                            },
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>

                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>


            </div>
        </div>

    )
}
export default EmployeeHistory;